import { useState, useEffect } from "react";
import { doFetch } from "./doFetch";
// import { _debug, _debugError } from "./DebugView";

export function useFetch(url, body, method = "POST", condition = true, headers, shouldParseJson = true) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(condition);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function fetchUrl(url, body, method) {
      try {
        if (!loading) setLoading(true);
        let json = await doFetch(url, body, method, headers, shouldParseJson);
        if (!mounted) return;
        setLoading(false);
        if (error) setError(false);
        setData(json);
        // console.debug({ status: response.status, data: JSON.stringify(json, null, 1).substr(0, 100) });
      } catch (err) {
        setLoading(false);
        setData([]);
        setError({ name: err?.toString(), body, method, url });
        console.error({ name: err?.toString(), body, method, url });
      }
    }

    const cleanup = () => (mounted = false);
    condition && fetchUrl(url, body, method);
    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, body, method, condition, headers, shouldParseJson]);
  return [data, loading, error];
}
